import { LOGOUT } from 'features/user/userTypes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LOAD_DATA } from 'reducers/reducersConstants';
import LocalStore from 'utils/LocalStore';
import { trackClick, trackingActions, trackingTypes } from 'utils/tracking';
import { AppConfig } from 'AppConfig';

const LOGOUT_IN_PROGRESS_FLAG = '__bi_logout_in_progress__';

const Logout = () => {
  const dispatch = useDispatch();

  const handleClearup = () => {
    sessionStorage.clear();
    LocalStore.clear();
    let allCookies = document.cookie.split(';');
    for (var i = 0; i < allCookies.length; i++) {
      let cookie = allCookies[i];
      let cookieName = decodeURIComponent(cookie.split('=')[0]).trim();
      if (!LocalStore.isLoginModeToken(cookieName)) {
        document.cookie = cookie + '=;expires=' + new Date(0).toUTCString();
      }
    }
    dispatch({
      type: LOAD_DATA,
      payload: {
        user: {
          id: null,
          username: null,
          firstname: null,
          lastname: null,
          lastLoginDt: null,
          currentApp: null,
          currentRole: null,
          currentTenantCd: null
        }
      }
    });
    dispatch({ type: LOGOUT });
  };

  useEffect(() => {
    if (window[LOGOUT_IN_PROGRESS_FLAG]) {
      return;
    }
    window[LOGOUT_IN_PROGRESS_FLAG] = true;

    const doLogout = () => {
      const rawUser = LocalStore.getLoginUser();
      let userObj = {};
      try {
        userObj = typeof rawUser === 'string' ? JSON.parse(rawUser) : rawUser || {};
      } catch (e) {
        userObj = {};
      }
      const { username, id, email } = userObj;
      const mergedUsername = [username, id, email].filter(Boolean).join('|'); // e.g. john.doe|1234|john.doe@claritev.com
      trackClick(trackingTypes.USER, trackingActions.LOGOUT, mergedUsername, null);

      setTimeout(() => {
        handleClearup();
        // Keep manual sign-out and token-expired logout behavior identical.
        const oktaLoginUrl = new URL(AppConfig.OKTA_URL);
        oktaLoginUrl.searchParams.set('prompt', 'login');
        window.location.href = oktaLoginUrl.toString();
      }, 1500);
    };
    doLogout();

    return () => {
      window[LOGOUT_IN_PROGRESS_FLAG] = false;
    };
  }, []);

  return <>Logging out</>;
};

export default Logout;
